import { ICallableRequestBuilder } from "@/api/requestBuilder/types";
import config from "@shared/config/client";
import queryString from "query-string";
import { PostCommentDto } from "./types";

const getPostComments =
  (request: ICallableRequestBuilder<PostCommentDto[]>) =>
  async ({
    postId,
    take,
    skip,
  }: {
    postId: string;
    take: number;
    skip: number;
  }) => {
    const url = queryString.stringifyUrl({
      url: `${config.apiUrl}/comments/post/${postId}`,
      query: { take, skip },
    });

    return await request.call(url, (init) => ({
      ...init,
      method: "GET",
    }));
  };

const requests = {
  getPostComments,
};

export default requests;
